import React from 'react'
import Banner from '../../components/Banner'
import cord from '../../assets/phone-cord.webp'

import ContactForm from '../../components/contactForm/ContactForm'
import Map from '../../components/Map'

const ContactPage = () => {
  return (
    <div className='page-wrapper bg-light'>
      <Banner img={cord}> 
        <h1 className='display-5 '>Contact Us<span className='text-info fw-bold'>.</span></h1> 
      </Banner>
      <ContactForm />
      <Map />
    </div>
  )
}

export default ContactPage